var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('NodeViewWrapper',{attrs:{"as":"span"}},[_c('span',{class:_vm.node.type.name,attrs:{"data-id":_vm.node.attrs['data-id']}},[_vm._v("-- choose --")])])}
var staticRenderFns = []

export { render, staticRenderFns }